import {css} from "@panda/css";

import {DEFAULT_INTEREST} from "../../../credit_calculator/constants/calculations_defaults";
import {convertInterestToText} from "../../../credit_calculator/utils/convert_interest_to_text";
import {BudgetField} from "../../../real_estate/components/fields/BudgetField";
import {BudgetFieldsNames} from "../../../real_estate/types/BudgetFieldsNames";
import {Currency} from "../../../types/Currency";

interface IProps {
    isInModal?: boolean;
    currency?: Currency;
    inputVariant?: "row" | "column";
    radioGroupClassName?: string;
    radioClassName?: string;
    fieldNames?: {radio: string; credit: string; total: string};
    maxPrice?: number;
    maxDisplayLabel?: string;
}

export const FilterBudget = (props: IProps) => {
    const {
        fieldNames = {
            radio: BudgetFieldsNames.RADIO,
            credit: BudgetFieldsNames.CREDIT,
            total: BudgetFieldsNames.TOTAL
        },
        maxPrice,
        maxDisplayLabel
    } = props;

    return (
        <div className={FilterBudgetWrapper}>
            <BudgetField
                type="switch"
                radioName={fieldNames.radio}
                totalInputName={fieldNames.total}
                monthlyInputName={fieldNames.credit}
                totalMax={maxPrice}
                useBudgetDynamicStep
                maxDisplayLabel={maxDisplayLabel}
                monthlyTitleTooltip={{
                    label: "Rata kredytu",
                    tooltip: `Kalkulacja raty kredytu opiera się na następujących założeniach: 20% wkładu własnego, oprocentowaniu na poziomie ${convertInterestToText(DEFAULT_INTEREST)} oraz okresie kredytowania wynoszącym 30 lat.`
                }}
                currency={props.currency}
                radioGroupClassName={props.radioGroupClassName}
                radioClassName={props.radioClassName}
                inputVariant={props.inputVariant}
            />
        </div>
    );
};

const FilterBudgetWrapper = css({
    paddingX: 1,
    marginBottom: 2,
    position: "relative"
});
import {css} from "@panda/css";

import {DEFAULT_INTEREST} from "../../../credit_calculator/constants/calculations_defaults";
import {convertInterestToText} from "../../../credit_calculator/utils/convert_interest_to_text";
import {BudgetField} from "../../../real_estate/components/fields/BudgetField";
import {BudgetFieldsNames} from "../../../real_estate/types/BudgetFieldsNames";
import {Currency} from "../../../types/Currency";

interface IProps {
    isInModal?: boolean;
    currency?: Currency;
    inputVariant?: "row" | "column";
    radioGroupClassName?: string;
    radioClassName?: string;
    fieldNames?: {radio: string; credit: string; total: string};
    maxPrice?: number;
    maxDisplayLabel?: string;
}

export const FilterBudget = (props: IProps) => {
    const {
        fieldNames = {
            radio: BudgetFieldsNames.RADIO,
            credit: BudgetFieldsNames.CREDIT,
            total: BudgetFieldsNames.TOTAL
        },
        maxPrice,
        maxDisplayLabel
    } = props;

    return (
        <div className={FilterBudgetWrapper}>
            <BudgetField
                type="switch"
                radioName={fieldNames.radio}
                totalInputName={fieldNames.total}
                monthlyInputName={fieldNames.credit}
                totalMax={maxPrice}
                useBudgetDynamicStep
                maxDisplayLabel={maxDisplayLabel}
                monthlyTitleTooltip={{
                    label: "Rata kredytu",
                    tooltip: `Kalkulacja raty kredytu opiera się na następujących założeniach: 20% wkładu własnego, oprocentowaniu na poziomie ${convertInterestToText(DEFAULT_INTEREST)} oraz okresie kredytowania wynoszącym 30 lat.`
                }}
                currency={props.currency}
                radioGroupClassName={props.radioGroupClassName}
                radioClassName={props.radioClassName}
                inputVariant={props.inputVariant}
            />
        </div>
    );
};

const FilterBudgetWrapper = css({
    paddingX: 1,
    marginBottom: 2,
    position: "relative"
});
